import { render, staticRenderFns } from "./IrisDisplayInputFieldUnspecified.vue?vue&type=template&id=0ee2a7bc&"
import script from "./IrisDisplayInputFieldUnspecified.vue?vue&type=script&lang=ts&"
export * from "./IrisDisplayInputFieldUnspecified.vue?vue&type=script&lang=ts&"
import style0 from "./IrisDisplayInputFieldUnspecified.vue?vue&type=style&index=0&id=0ee2a7bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports